import { render } from "./notification-view-modal.vue?vue&type=template&id=23ceab08"
import script from "./notification-view-modal.vue?vue&type=script&lang=js"
export * from "./notification-view-modal.vue?vue&type=script&lang=js"

import "./notification-view-modal.vue?vue&type=style&index=0&id=23ceab08&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__